import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link, useParams,useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const TopicDetails = () => {

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const topicId = searchParams.get("id");

  const [topic, setTopic] = useState({});
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/topic_details/${topicId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setTopic(res.data.data);
      setAttachments(res.data.data.attachments);

    } catch (err) {
      toast.error("Failed to load topic details");
    }
  };

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();

    if (ext === "pdf") return "/assets/pdf_icon.png";
    if (ext === "doc" || ext === "docx") return "/assets/word_icon.png";
    if (ext === "ppt" || ext === "pptx") return "/assets/ppt_icon.png";
    return "";
  };

  return (
    <>
      <ToastContainer />

      <div className="section-body">
        <div className="container-fluid">

          <div className="card">
            <div className="card-header">
              <h3 className="card-title" style={{ color: "#e96827" }}>
                View Topic Details
              </h3>
            </div>

            <div className="card-body">

              <div className="row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: 600 }}>Topic Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={topic.topic_name || ""}
                      readOnly
                    />
                  </div>
                </div>

              </div>

              <div className="row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: 600 }}>Description</label>
                    <textarea
                      className="form-control"
                      rows="8"
                      value={topic.description || ""}
                      readOnly
                    />
                  </div>
                </div>

                {topic.youtube_url && (
                  <div className="col-md-6 text-center">
                    <label style={{ fontWeight: 600 }}>Video</label>
                    <br />
                    <a
                      href={topic.youtube_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/assets/youtube_icon.png"
                        alt="youtube"
                        style={{ width: 200, height: 200 }}
                      />
                    </a>
                  </div>
                )}

              </div>

              {/* Attachments */}
              <div className="row mt-4">
                <div className="col-md-12">
                  <label style={{ fontWeight: 600 }}>Attachments</label>
                </div>
              </div>

              <div className="row">
                {attachments.map((file, index) => (
                  <div className="col-sm-2" key={index}>
                    <a
                      href={`${API_BASE_URL.replace('/api','')}/uploads/topic/${file.attachement}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={getFileIcon(file.attachement)}
                        alt="file"
                        style={{ width: 60, height: 60 }}
                      />
                    </a>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default TopicDetails;